export default {
      id: "logo-usage",
      viewBox: "0 0 135 120",
      url: "../dist/images/" + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }